import { metadataConfig } from 'shared/domains/metadata';
import { SUPPORTED_PROPERTIES } from './constants';
import { getMetadataPropertyGroups } from './getMetadataPropertyGroups';
export const getMetadataProperties = (query) => {
    const config = metadataConfig.getAll();
    const keepSupported = (property) => SUPPORTED_PROPERTIES.includes(property.name);
    const matchQuery = (property) => property.label.toLocaleLowerCase().includes(query.toLocaleLowerCase());
    const sortAlphabetically = (a, b) => a.label.localeCompare(b.label);
    const supportedProperties = config.filter(keepSupported).filter(matchQuery).sort(sortAlphabetically);
    const groupedProperties = getMetadataPropertyGroups(supportedProperties);
    return {
        propertyGroups: groupedProperties,
        allProperties: supportedProperties,
    };
};
